'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _dialog = require('../dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _timePickerButton = require('./time-picker-button/time-picker-button');

var _timePickerButton2 = _interopRequireDefault(_timePickerButton);

require('./time-picker.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dateTimeFormatter = require('../../utils/date-time-formatter');

var _scrollToElement = require('../../utils/scroll-to-element');

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIME_VIEW = 'TIME';
var HOUR_VIEW = 'HOUR';
var MINUTE_VIEW = 'MINUTE';

var TimePicker = function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    _classCallCheck(this, TimePicker);

    var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

    _this.state = {
      viewType: TIME_VIEW,
      selectedTime: +new Date().setMinutes('00'),
      isTimePickerVisible: false
    };

    _this.openTimePicker = _this.openTimePicker.bind(_this);
    _this.closeTimePicker = _this.closeTimePicker.bind(_this);

    _this.handleTimePick = _this.handleTimePick.bind(_this);
    _this.handleTimeChange = _this.handleTimeChange.bind(_this);
    _this.handleHourIncrease = _this.handleHourIncrease.bind(_this);
    _this.handleHourSelection = _this.handleHourSelection.bind(_this);
    _this.handleHourDecrease = _this.handleHourDecrease.bind(_this);
    _this.handleMinuteIncrease = _this.handleMinuteIncrease.bind(_this);
    _this.handleMinuteSelection = _this.handleMinuteSelection.bind(_this);
    _this.handleMinuteDecrease = _this.handleMinuteDecrease.bind(_this);
    _this.handleDayPeriodChange = _this.handleDayPeriodChange.bind(_this);
    return _this;
  }

  _createClass(TimePicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var value = this.props.value;
      var selectedTime = this.state.selectedTime;


      if (value && selectedTime !== value) {
        this.setStateFromValue(value);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedTime = this.state.selectedTime;


      if (nextProps.value && this.getUTCFormatterDate(selectedTime) !== nextProps.value) {
        this.setStateFromValue(nextProps.value);
      }
    }
  }, {
    key: 'getUTCFormatterDate',
    value: function getUTCFormatterDate(selectedDate) {
      return Math.floor(selectedDate / 1000);
    }
  }, {
    key: 'setStateFromValue',
    value: function setStateFromValue(value) {
      var date = +new Date(parseInt(value, 10) * 1000);

      if (typeof value === 'string') {
        this.setState({
          selectedTime: +new Date(),
          inputValue: ''
        });

        return;
      }

      this.setState({
        selectedTime: date,
        inputValue: date
      });
    }
  }, {
    key: 'getTimeFromLocales',
    value: function getTimeFromLocales() {
      var inputValue = this.state.inputValue;
      var locales = this.props.locales;


      return (0, _dateTimeFormatter.getTime)(inputValue, locales);
    }
  }, {
    key: 'getHours',
    value: function getHours() {
      var selectedTime = this.state.selectedTime;

      var date = new Date(selectedTime);

      return date.getHours();
    }
  }, {
    key: 'getMinutes',
    value: function getMinutes() {
      var selectedTime = this.state.selectedTime;

      var date = new Date(selectedTime);

      return date.getMinutes();
    }
  }, {
    key: 'getFormattedTime',
    value: function getFormattedTime(time) {
      return Math.floor(time / 1000);
    }
  }, {
    key: 'getHumanReadableSelectedHour',
    value: function getHumanReadableSelectedHour() {
      var locales = this.props.locales;
      var selectedTime = this.state.selectedTime;

      var hour = Intl.DateTimeFormat(locales, { hour: 'numeric' }).format(new Date(selectedTime));

      return parseInt(hour, 10).toString().padStart(2, 0);
    }
  }, {
    key: 'getHumanReadableSelectedMinute',
    value: function getHumanReadableSelectedMinute() {
      return parseInt(this.getMinutes(), 10).toString().padStart(2, 0);
    }
  }, {
    key: 'getHumanReadableSelectedDayPeriod',
    value: function getHumanReadableSelectedDayPeriod() {
      return this.getHours() >= 12 ? 'PM' : 'AM';
    }
  }, {
    key: 'getHumanReadableTime',
    value: function getHumanReadableTime() {
      var is12hrFormatInUse = this.shouldUse12hFormat();
      var hour = this.getHumanReadableSelectedHour();
      var minute = this.getHumanReadableSelectedMinute();
      var dayPeriodLabel = this.getHumanReadableSelectedDayPeriod();

      return is12hrFormatInUse ? hour + ':' + minute + ' ' + dayPeriodLabel : hour + ':' + minute;
    }
  }, {
    key: 'closeTimePicker',
    value: function closeTimePicker() {
      this.setState({ isTimePickerVisible: false, viewType: TIME_VIEW });
    }
  }, {
    key: 'openTimePicker',
    value: function openTimePicker() {
      if (this.props.disabled) {
        return;
      }

      this.setState({ isTimePickerVisible: true });
    }
  }, {
    key: 'handleTimePick',
    value: function handleTimePick() {
      var onChange = this.props.onChange;
      var selectedTime = this.state.selectedTime;

      var formattedTime = this.getFormattedTime(selectedTime);

      this.setState({ inputValue: selectedTime }, function () {
        return onChange(formattedTime);
      });
    }
  }, {
    key: 'handleTimeChange',
    value: function handleTimeChange(_ref) {
      var hour = _ref.hour,
          minute = _ref.minute;
      var selectedTime = this.state.selectedTime;

      var selectedDate = new Date(selectedTime);
      var nextHour = hour !== undefined ? hour : selectedDate.getHours();
      var nextMinute = minute !== undefined ? minute : selectedDate.getMinutes();

      var nextSelectedTime = +new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), nextHour, nextMinute, 0);

      this.setState({ selectedTime: nextSelectedTime });
    }
  }, {
    key: 'handleHourIncrease',
    value: function handleHourIncrease() {
      var selectedHour = this.getHours();
      var hour = selectedHour === 23 ? 0 : selectedHour + 1;

      this.handleTimeChange({ hour: hour });
    }
  }, {
    key: 'handleHourDecrease',
    value: function handleHourDecrease() {
      var selectedHour = this.getHours();
      var hour = selectedHour === 0 ? 23 : selectedHour - 1;

      this.handleTimeChange({ hour: hour });
    }
  }, {
    key: 'handleHourSelection',
    value: function handleHourSelection(hour) {
      var _this2 = this;

      this.setState({ viewType: TIME_VIEW }, function () {
        return _this2.handleTimeChange({ hour: hour });
      });
    }
  }, {
    key: 'handleMinuteIncrease',
    value: function handleMinuteIncrease() {
      var selectedMinute = this.getMinutes();
      var minute = selectedMinute === 59 ? 0 : selectedMinute + 1;

      this.handleTimeChange({ minute: minute });
    }
  }, {
    key: 'handleMinuteDecrease',
    value: function handleMinuteDecrease() {
      var selectedMinute = this.getMinutes();
      var minute = selectedMinute === 0 ? 59 : selectedMinute - 1;

      this.handleTimeChange({ minute: minute });
    }
  }, {
    key: 'handleMinuteSelection',
    value: function handleMinuteSelection(minute) {
      var _this3 = this;

      this.setState({ viewType: TIME_VIEW }, function () {
        return _this3.handleTimeChange({ minute: minute });
      });
    }
  }, {
    key: 'handleDayPeriodChange',
    value: function handleDayPeriodChange() {
      var selectedHour = this.getHours();
      var hour = selectedHour >= 12 ? selectedHour - 12 : selectedHour + 12;

      this.handleTimeChange({ hour: hour });
    }
  }, {
    key: 'shouldUse12hFormat',
    value: function shouldUse12hFormat() {
      var selectedTime = this.state.selectedTime;
      var locales = this.props.locales;

      var hour = Intl.DateTimeFormat(locales, { hour: 'numeric' }).format(new Date(selectedTime));

      return (/AM|PM/.test(hour)
      );
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var disabled = this.props.disabled;
      var inputValue = this.state.inputValue;


      var inputProps = {
        label: this.props.label,
        placeholder: this.props.placeholder,
        size: this.props.size,
        validationMessage: this.props.validationMessage,
        validationMessageTemplate: this.props.validationMessageTemplate,
        state: this.props.state,
        'data-e2e': 'time-picker'
      };

      if (disabled) {
        inputProps.disabled = disabled;
      }

      var timeToRender = inputValue ? this.getTimeFromLocales() : '';

      var classes = (0, _classnames2.default)('time-picker-input', disabled && 'time-picker-input--disabled');

      return _react2.default.createElement(_input2.default, _extends({
        className: classes,
        value: timeToRender,
        readOnly: true,
        prefix: _react2.default.createElement(_icon2.default, { name: 'generic-clock', size: '18', className: 'date-picker-calendar-icon' }),
        onClick: this.openTimePicker
      }, inputProps));
    }
  }, {
    key: 'renderTimePickerDialog',
    value: function renderTimePickerDialog() {
      var _state = this.state,
          isTimePickerVisible = _state.isTimePickerVisible,
          viewType = _state.viewType;
      var className = this.props.className;

      var classes = (0, _classnames2.default)('time-picker', className);

      if (!isTimePickerVisible) {
        return null;
      }

      return _react2.default.createElement(
        _dialog2.default,
        {
          className: classes,
          density: 'none',
          size: 'small',
          footer: this.renderFooter(),
          onCloseHandler: this.closeTimePicker
        },
        viewType === TIME_VIEW && this.renderClock(),
        viewType === HOUR_VIEW && this.renderHourPicker(),
        viewType === MINUTE_VIEW && this.renderMinutePicker()
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _this4 = this;

      var translation = this.props.translation;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _button2.default,
          { onClick: this.closeTimePicker },
          translation.cancelButton
        ),
        _react2.default.createElement(
          _button2.default,
          {
            color: 'primary',
            disabled: this.props.shouldDisableTime(this.getFormattedTime(this.state.selectedTime)),
            onClick: function onClick() {
              _this4.handleTimePick();
              _this4.closeTimePicker();
            }
          },
          translation.okButton
        )
      );
    }
  }, {
    key: 'renderClock',
    value: function renderClock() {
      var _this5 = this;

      var is12hrFormatInUse = this.shouldUse12hFormat();
      var hour = this.getHumanReadableSelectedHour();
      var minute = this.getHumanReadableSelectedMinute();
      var dayPeriodLabel = this.getHumanReadableSelectedDayPeriod();

      return _react2.default.createElement(
        'div',
        { className: 'time-picker__content time-picker__content--flex' },
        _react2.default.createElement(
          'div',
          { className: 'time-picker__column' },
          _react2.default.createElement(
            _timePickerButton2.default,
            { color: 'secondary', onClick: this.handleHourIncrease },
            _react2.default.createElement(_icon2.default, { name: 'arrow-up', size: '16' })
          ),
          _react2.default.createElement(
            _timePickerButton2.default,
            { size: 'xx-large', onClick: function onClick() {
                return _this5.setState({ viewType: HOUR_VIEW });
              } },
            hour
          ),
          _react2.default.createElement(
            _timePickerButton2.default,
            { color: 'secondary', onClick: this.handleHourDecrease },
            _react2.default.createElement(_icon2.default, { name: 'arrow-down', size: '16' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'time-picker__column time-picker__column--justify-center' },
          ':'
        ),
        _react2.default.createElement(
          'div',
          { className: 'time-picker__column' },
          _react2.default.createElement(
            _timePickerButton2.default,
            { color: 'secondary', onClick: this.handleMinuteIncrease },
            _react2.default.createElement(_icon2.default, { name: 'arrow-up', size: '16' })
          ),
          _react2.default.createElement(
            _timePickerButton2.default,
            { size: 'xx-large', onClick: function onClick() {
                return _this5.setState({ viewType: MINUTE_VIEW });
              } },
            minute
          ),
          _react2.default.createElement(
            _timePickerButton2.default,
            { color: 'secondary', onClick: this.handleMinuteDecrease },
            _react2.default.createElement(_icon2.default, { name: 'arrow-down', size: '16' })
          )
        ),
        is12hrFormatInUse && _react2.default.createElement(
          'div',
          { className: 'time-picker__column time-picker__column--justify-center time-picker__column--margin-start' },
          _react2.default.createElement(
            _timePickerButton2.default,
            { background: 'secondary', onClick: this.handleDayPeriodChange },
            dayPeriodLabel
          )
        )
      );
    }
  }, {
    key: 'renderHourPicker',
    value: function renderHourPicker() {
      var _this6 = this;

      var selectedHour = this.getHours();
      var is12hrFormatInUse = this.shouldUse12hFormat();
      var hoursInDay = is12hrFormatInUse ? 12 : 24;
      var hours = new Array(hoursInDay).fill(null).map(function (e, i) {
        return is12hrFormatInUse ? i + 1 : i;
      });

      return _react2.default.createElement(
        'div',
        { className: 'time-picker__content' },
        hours.map(function (hour) {
          var isSelected = selectedHour === hour;
          var classes = (0, _classnames2.default)('time-picker-entity', isSelected && 'time-picker-entity--selected');

          return _react2.default.createElement(
            'span',
            {
              key: hour,
              ref: function ref(_ref2) {
                return isSelected && (0, _scrollToElement2.default)(_ref2, { block: 'center' });
              }
            },
            _react2.default.createElement(
              _text2.default,
              {
                className: classes,
                color: 'dark',
                weight: 'bold',
                onClick: function onClick() {
                  return _this6.handleHourSelection(hour);
                }
              },
              hour.toString().padStart(2, 0)
            )
          );
        })
      );
    }
  }, {
    key: 'renderMinutePicker',
    value: function renderMinutePicker() {
      var _this7 = this;

      var selectedMinute = this.getMinutes();
      var minutes = new Array(60).fill(null).map(function (e, i) {
        return i;
      });

      return _react2.default.createElement(
        'div',
        { className: 'time-picker__content' },
        minutes.map(function (minute) {
          var isSelected = selectedMinute === minute;
          var classes = (0, _classnames2.default)('time-picker-entity', isSelected && 'time-picker-entity--selected');

          return _react2.default.createElement(
            'span',
            {
              key: minute,
              ref: function ref(_ref3) {
                return isSelected && (0, _scrollToElement2.default)(_ref3, { block: 'center' });
              }
            },
            _react2.default.createElement(
              _text2.default,
              {
                className: classes,
                weight: 'bold',
                onClick: function onClick() {
                  return _this7.handleMinuteSelection(minute);
                }
              },
              minute.toString().padStart(2, 0)
            )
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        this.renderInput(),
        this.renderTimePickerDialog()
      );
    }
  }]);

  return TimePicker;
}(_react2.default.Component);

TimePicker.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  locales: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  shouldDisableTime: _propTypes2.default.func,
  translation: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,

  // Input // TODO start exporting component properties, for easier reuse
  label: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  validationMessage: _propTypes2.default.string,
  validationMessageTemplate: _propTypes2.default.func,
  state: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint'])
};

TimePicker.defaultProps = {
  locales: navigator.language || 'en-US',
  placeholder: 'Select a time',
  onChange: function onChange() {
    return false;
  },
  shouldDisableTime: function shouldDisableTime() {
    return false;
  },

  translation: {
    cancelButton: 'Cancel',
    okButton: 'Ok'
  }
};

exports.default = TimePicker;